// Pre-computed base64 data for preset backgrounds
// Generated at build time for instant loading (no network requests)
import presetBase64 from './presetBase64.json'

export interface PresetBackground {
  id: string
  name: string
  description: string
  url: string
  // Color used for placeholder/fallback display
  fallbackColor: string
  // Pre-computed base64 for instant generation (no network fetch needed)
  base64: string
}

export const presetBackgrounds: PresetBackground[] = [
  {
    id: 'white-clean',
    name: 'Clean White',
    description: 'Pure white studio background for clean product shots',
    url: 'https://images.kalypsoai.com/presets/white%20clean.jpg',
    fallbackColor: '#FFFFFF',
    base64: presetBase64['white-clean'],
  },
  {
    id: 'marble',
    name: 'Marble Surface',
    description: 'Elegant marble surface for luxury product photography',
    url: 'https://images.kalypsoai.com/presets/Marble.jpg',
    fallbackColor: '#E8E4E0',
    base64: presetBase64['marble'],
  },
  {
    id: 'wood-warm',
    name: 'Warm Wood',
    description: 'Natural warm wood texture for organic, artisan products',
    url: 'https://images.kalypsoai.com/presets/Wood.png',
    fallbackColor: '#B5896E',
    base64: presetBase64['wood-warm'],
  },
  {
    id: 'botanical',
    name: 'Botanical',
    description: 'Fresh botanical setting with leaves and natural elements',
    url: 'https://images.kalypsoai.com/presets/botanical.jpg',
    fallbackColor: '#A8C5A8',
    base64: presetBase64['botanical'],
  },
]
